module.exports = __webpack_public_path__ + "img/home_point.0f6e4b6b.png";